<div class="seller-vacation">
    <app-header
        [hasBackButton]="!isList"
        [hasButtons]="true"
        [hasSearchButton]="false"
        [hasMinCharacters]="false"
        [searchInput]="filter"
        [searchPlaceholder]="isList ? ('support.seller-vacation.header.filter' | translate) : null"
        [title]="(('support.seller-vacation.header.title.' + (isList ? 'list' : 'create')) | translate )"
        (onSearch)="onSearch($event)"
        (onGoBack)="goBackToList()"
    >
        @if (isList) {
            <button customButton styleType="primary" class="create-vacation" iconName="plus" [label]="'support.seller-vacation.header.button.create-vacation' | translate" [isLoading]="false" (click)="openCreateVacation()"></button>
        }
    </app-header>

    @if (isList) {
        <app-seller-vacation-list [sellersOnVacation]="sellersOnVacationFiltered"></app-seller-vacation-list>
    } @else {
        <app-seller-vacation-manage (goBackToList)="goBackToList($event)"></app-seller-vacation-manage>
    }
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
